import React from 'react';
import {NavLink} from 'fluxible-router';
import WineSku from '../../../models/WineSku';
import DelectableRating from '../../DelectableRating';
import styles from './index.sass';

class UniversalSearchResult extends React.Component {
  static propTypes = {
    wineSku: React.PropTypes.instanceOf(WineSku).isRequired,
  };

  static contextTypes = {
    buildURLForRoute: React.PropTypes.func
  };

  render() {
    let wineSku = this.props.wineSku;
    let wineProfile = wineSku.wine_profile;
    let delectableRating;
    if(wineProfile.rating) {
      let delectableRatingProps = {
        rating: wineProfile.rating.average_rating,
        count: wineProfile.rating.ratings_count,
        style: {display: 'inline-block', whiteSpace: 'pre'}
      };
      delectableRating = <DelectableRating {...delectableRatingProps} />;
    }
    let url = this.context.buildURLForRoute('wineSku', {
      slug: wineSku.slug,
      id: wineSku.id
    });
    return (
      <NavLink className={styles.universalSearchResult} href={url}>
        <div className={styles.details}>
          <p className={styles.name}>{wineProfile.producer} {wineProfile.name}</p>
          <div className={styles.ratingAndPriceRow}>
            {delectableRating}
            {delectableRating ? <span className={styles.bullet}>•</span> : null}
            <span className={styles.priceRange}>{wineSku.price_range_text}</span>
            <span className={styles.bullet}>•</span>
            <span className={styles.message}>{wineSku.volume_text}</span>
          </div>
        </div>
        <img className={styles.photo} src={wineProfile.photo_hash.getClosestToTarget(120)} />
      </NavLink>
    );
  }
}

export default UniversalSearchResult;



// WEBPACK FOOTER //
// banquet/components/UniversalSearchResultsList/UniversalSearchResult/index.js